module.exports = __webpack_public_path__ + "static/media/thumbnail.4229b538.jpg";